module.exports = __webpack_public_path__ + "media/img/bg-slide-41f5b244.png";